import React from 'react';
import { motion } from 'framer-motion';
import { Camera, Scan, MapPin, Heart } from 'lucide-react';

const ONBOARDING_STEPS = [
  {
    icon: Camera,
    title: 'Capture',
    description: 'Tire uma foto clara do solado do pé direito.',
    accent: '#22D3EE',
  },
  {
    icon: Scan,
    title: 'Escaneie',
    description: 'A IA processa pontos reflexos em segundos.',
    accent: '#0F766E',
  },
  {
    icon: MapPin,
    title: 'Analise',
    description: 'Receba zonas de reatividade mapeadas.',
    accent: '#D4A256',
  },
  {
    icon: Heart,
    title: 'Cuide-se',
    description: 'Protocolo de autocuidado personalizado.',
    accent: '#22D3EE',
  },
];

const OnboardingSteps = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
      {ONBOARDING_STEPS.map((step, index) => {
        const Icon = step.icon;
        return (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-50px' }}
            transition={{ delay: index * 0.12, duration: 0.5, ease: 'easeOut' }}
            whileHover={{ y: -6 }}
            className="relative group"
          >
            {/* Glow halo */}
            <div
              className="absolute inset-0 rounded-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-500 -z-10"
              style={{
                background: `radial-gradient(circle at center, ${step.accent}33 0%, transparent 70%)`,
                filter: 'blur(20px)',
              }}
            />

            {/* Card */}
            <div
              className="relative rounded-3xl p-6 h-full overflow-hidden transition-all"
              style={{
                background: 'rgba(8, 61, 58, 0.04)',
                border: `1px solid ${step.accent}33`,
                backdropFilter: 'blur(10px)',
              }}
            >
              {/* Top gradient strip */}
              <div
                className="absolute top-0 left-0 right-0 h-[2px]"
                style={{ background: `linear-gradient(90deg, transparent, ${step.accent}, transparent)` }}
              />

              {/* Step number */}
              <div className="flex items-start justify-between mb-4">
                <div
                  className="w-14 h-14 rounded-2xl flex items-center justify-center relative"
                  style={{
                    background: `${step.accent}15`,
                    border: `1px solid ${step.accent}40`,
                    boxShadow: `0 0 20px ${step.accent}30`,
                  }}
                >
                  <Icon className="w-7 h-7" style={{ color: step.accent }} />
                </div>
                <span
                  className="font-mono text-xs font-bold tracking-wider"
                  style={{ color: `${step.accent}90` }}
                >
                  0{index + 1}
                </span>
              </div>

              <h3
                className="font-bold text-xl mb-2 text-[#083D3A]"
                style={{ fontFamily: 'Syne, sans-serif' }}
              >
                {step.title}
              </h3>
              <p className="text-sm text-[#4B5563] leading-relaxed">{step.description}</p>
            </div>
          </motion.div>
        );
      })}
    </div>
  );
};

export default OnboardingSteps;
